import { ReactElement, useEffect, useState } from 'react'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import { useBFSM } from '../../../contexts/bfsmContext'
import {
    BasisActions,
    BasisState,
    CheckoutState,
    DetailsState,
} from '@raskrask-dk/bookingflow-state-machine'
import PaymentOverviewTemplate from './template'
import { PropsDiscount } from './props'
import { useTranslation } from 'react-i18next'
import { adaptorToGetPaymentInfoOnDetailsState } from '../../details/adaptors'
import { BasisTypeBF } from '../../../models'
import { IPaymentPrice, Booking } from '@raskrask-dk/raskrask-utils'

const PaymentOverviewPage = (): ReactElement => {
    const [BFSM] = useBFSM()
    const { t } = useTranslation()
    const [customerType] = useBFSMValue<
        BasisState,
        BasisActions.SetCustomerType,
        'customerType'
    >('customerType')
    const [basisType] = useBFSMValue<
        BasisState,
        BasisActions.SetBasisType,
        'basisType'
    >('basisType')
    const product = BFSM.getData<CheckoutState>().product

    const [paymentInfo, setPaymentInfo] = useState<IPaymentPrice>()

    // THis is old. Shall we kkep it?
    // const paymentInfo = useAppSelector((state) => getPaymentInfo(state))

    useEffect(() => {
        const getpaymentinfo = async () => {
            const data = BFSM.getData<DetailsState>()
            const input = adaptorToGetPaymentInfoOnDetailsState(data, false)
            const paymentInfo = await BFSM.repo.getPaymentInfo(input)
            setPaymentInfo(paymentInfo)
        }
        getpaymentinfo()
    }, [])

    const isPackage = product.type === 'Package'

    if (!paymentInfo) return <></>

    const { price, priceExclVat, discountList, totalDiscountAmount } =
        paymentInfo

    const isCompanyOneOff =
        product instanceof Booking && customerType === 'Company' ? true : false

    const shouldShowPriceDetails = totalDiscountAmount > 0 || isCompanyOneOff
    const shouldShowVatPrice =
        isCompanyOneOff &&
        (discountList?.type === undefined ||
            discountList?.type !== 'PromoDiscount')

    const finalPrice = price
    const vatPrice = finalPrice - (priceExclVat || finalPrice)
    const initialPrice = finalPrice + totalDiscountAmount

    const getKeyNameOfDiscount = (key: string): string => {
        switch (key) {
            case 'CardCodeDiscount':
                return 'giftklippediscounttext'
            case 'PromoDiscount':
                return 'promocodediscounttext'
            case 'ReturningCustomerDiscount':
                return 'returningcustomerdiscounttext'
            case 'DiscountAfterKlipps':
                return 'klippekortDiscount'
            default:
                return ''
        }
    }

    const adaptor = (list: typeof discountList): PropsDiscount[] => {
        if (list === undefined) return []
        const text = t(
            `checkout.paymentoverview.${getKeyNameOfDiscount(list.type)}`
        )
        return [
            {
                text: text,
                price: list.amount,
            },
        ]
    }

    return (
        <PaymentOverviewTemplate
            discountList={adaptor(discountList)}
            finalPrice={finalPrice}
            initialPrice={initialPrice}
            shouldShowPriceDetails={shouldShowPriceDetails}
            shouldShowVatPrice={shouldShowVatPrice}
            vatPrice={vatPrice}
            basisType={basisType! as BasisTypeBF}
            isPackage={isPackage}
        />
    )
}

export default PaymentOverviewPage
